/** Used by navigation links that stay on the current page, so the click is visible. */
export const scrollToTop = (): void => window.scrollTo({ top: 0, behavior: 'smooth' });
